
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/cup-drinking-practice",
      function () {
        return require("private-next-pages/blog/cup-drinking-practice.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/cup-drinking-practice"])
      });
    }
  